import { Tabs as TabsPrimitive } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const TabsTrigger = React.forwardRef(({ className, children, ...props }, ref) => {
    return (React.createElement(TabsPrimitive.Tab, { ref: ref, className: cn("in-tabs__trigger", className), ...props }, children));
});
TabsTrigger.displayName = "TabsTrigger";
export { TabsTrigger };
//# sourceMappingURL=tabsTrigger.js.map